<script setup lang="ts">
import { ReserveType } from '@utils/itinerary';
import type { Radio } from '#imports';
import SearchReserveForm from '@components/util/search/SearchReserveForm.vue';
import { type SellTypeCode, trainSellTypes } from '@utils/train';
import { SearchMode } from '@utils/types';

const { isChangeSearch, loading } = defineProps<{
    isChangeSearch?: boolean;
    loading?: boolean;
}>();
const trainForm = useTrainForm();
const { exclusive, sellType, paxMaxSizeMessage } = moduleToRefs(trainForm);
const form = useTripSearchForm(isChangeSearch);
const sellTypeCode = computed({
    get(): SellTypeCode {
        return trainForm.sellType.code;
    },
    set(val: SellTypeCode) {
        trainForm.setSellTypeCode(val);
        if (!isChangeSearch) {
            trainForm.loadPrices();
        }
    },
});
const sellTypes = computed<Radio<SellTypeCode>[]>(() =>
    trainSellTypes.map(s => ({
        label: s.title,
        value: s.code,
    }))
);
const trainOptions = [{ label: 'داخلی', value: SearchMode.Domestic }];
</script>

<template>
    <SearchReserveForm
        v-bind="form"
        :reserve-type="ReserveType.Train"
        :is-change-search
        :loading
        :search-mode-options="trainOptions"
        origin-title="ایستگاه مبدأ"
        destination-title="ایستگاه مقصد"
        :pax-picker-options="{
            unit: sellType.code === 4 ? 'دستگاه' : 'مسافر',
            disabled: sellType.code === 4,
            maxAlert: paxMaxSizeMessage,
        }"
    >
        <template #mode-selector>
            <mr-checkbox
                v-model="exclusive"
                size="large"
                bold-label
                :disabled="sellTypeCode === 4"
                label="کوپه دربست"
            />
        </template>
        <template #pax-picker-content>
            <mr-divider title="فقط نمایش سهمیه‌های" class="mr-divider" />
            <mr-radio-button
                v-model="sellTypeCode"
                :radios="sellTypes"
                :gap-items="8"
                size="large"
                name="sell-types"
                @update:model-value="form.paxErrorMessage.value = undefined"
            />
        </template>
    </SearchReserveForm>
</template>
